import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_admin',
  components: {
    labSel: function labSel() {
      return import('../../org/lab_sel');
    },
    monitorSel: function monitorSel() {
      return import('../monitor/monitor_sel');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      roleDatas: [],
      pageConfig: {
        editPageName: '巡检任务',
        addFunName: 'oemDeviceTaskAdd',
        modifyFunName: 'oemDeviceTaskModify',
        queryFunName: 'oemDeviceTaskQuery',
        detailFunName: 'oemDeviceTaskDetail',
        delFunName: 'oemDeviceTaskDel'
      },
      searchForm: {
        // labId: localStorage.getItem('labId')
        page: 1,
        limit: 10
      },
      formData: {
        taskCategory: 'Plan',
        taskType: 'Inspection'
      },
      taskCategory: {
        Plan: '计划任务',
        Ad_Hoc: '临时任务'
      },
      taskType: {
        Inspection: '巡检',
        Maintenance: '保养'
      },
      taskPeriodUnit: {
        Minute: '分钟',
        Hour: '小时',
        Day: '天',
        Month: '月',
        Year: '年'
      },
      rules: {
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        taskTime: [{
          required: true,
          message: '请选择任务时间',
          trigger: 'blur'
        }],
        taskCategory: [{
          required: true,
          message: '请选择任务类别',
          trigger: 'blur'
        }],
        taskType: [{
          required: true,
          message: '请选择任务类型',
          trigger: 'blur'
        }],
        taskContent: [{
          required: true,
          message: '请输入任务内容',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      labShow: false,
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false,
      monitor_show: false
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.taskTime) {
        paramData.taskTime = dayjs(paramData.taskTime).format('YYYY-MM-DD HH:mm:ss');
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(_ref) {
      var _this = this;
      var id = _ref.id,
        labName = _ref.labName,
        deviceName = _ref.deviceName;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
          labName: labName,
          deviceName: deviceName
        }));
        _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
        _this.editDialogShow = true;
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, "oemDeviceId", null);
        this.$set(this.formData, "deviceName", null);
      }
      this.labShow = false;
    },
    monitorClick: function monitorClick() {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业！');
        return;
      }
      this.monitor_show = true;
    },
    monitorSel: function monitorSel(data) {
      if (data) {
        this.$set(this.formData, "oemDeviceId", data.id);
        this.$set(this.formData, "deviceName", data.name);
      }
      this.monitor_show = false;
    },
    del: function del(id) {
      var _this2 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
      this.queryLoading = false;
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};